import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import modalConnect from '@saucelabs/sl-container-modal';
import { Modal } from '@saucelabs/sl-component-overlay';

import SetGroupConcurrencyForm from './SetGroupConcurrencyForm';
import Styles from './SetGroupConcurrencyModal.styles';

const name = 'setGroupConcurrency';

class SetGroupConcurrencyModal extends Component {
  formHandler = { submit: null }

  shouldComponentUpdate(nextProps) {
    const { show } = this.props;
    return show !== nextProps.show || nextProps.show;
  }

  render() {
    const {
      currentVM,
      handleSubmit,
      maxVM,
      onHide,
      show,
    } = this.props;

    return (
      <Modal
        onHide={onHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Adjust Maximum Concurrency For All Teams</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Note: Line of Business (LoB) allows you to set the maximum concurrency
            that teams can use. A team’s concurrency can be less than or equal to
            the total concurrency in this LoB. You are able to adjust the concurrency
            for teams in this line of business only.
          </p>
          <h5 className={Styles['section-header']}>Virtual Machines</h5>
          <SetGroupConcurrencyForm
            formHandler={this.formHandler}
            initialValues={{ virtual_machines: currentVM || 0 }}
            maxVM={maxVM}
            setConcurrency={(data) => handleSubmit(data).then(onHide)}
          />
          <ul className={Styles['extra-info']}>
            <li>
              {'Org. Max: '}
              {maxVM}
            </li>
            <li>
              {'Previous: '}
              {currentVM || 'None'}
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={onHide}
            size="sm"
          >
            Cancel
          </Button>
          <Button
            category="primary"
            material
            onClick={() => this.formHandler.submit()}
            size="sm"
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SetGroupConcurrencyModal.propTypes = {
  currentVM: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  maxVM: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default modalConnect(name, SetGroupConcurrencyModal);
export { name, SetGroupConcurrencyModal };
